import React, { useEffect } from 'react';
import { Control, useController } from 'react-hook-form';

import { DocumentsUpload } from '@/domain/job-application/components';
import { useOtherDocumentsUploadProps } from '@/domain/job-application/contexts';
import { LIFormFieldValues, LOFormFieldValues } from '@/domain/job-application/types';

type Props = {
  control: Control<LOFormFieldValues | LIFormFieldValues>;
  updateValue: (value: string, field: 'cvDoc' | 'otherDocs') => void;
};

export const OtherDocumentsUploadField: React.VFC<Props> = ({ control, updateValue }) => {
  const { uploads, ...docUploadProps } = useOtherDocumentsUploadProps();

  const {
    field: { ref: otherDocsFieldRef, value: otherDocsFieldValue },
  } = useController({
    name: 'otherDocs',
    control,
    defaultValue: '',
  });

  useEffect(() => {
    const updatedUploads = uploads
      .map(({ id }) => id)
      .filter(Boolean)
      .join(',');
    if (otherDocsFieldValue !== updatedUploads) updateValue(updatedUploads, 'otherDocs');
  }, [uploads, otherDocsFieldValue, updateValue]);

  return (
    <section>
      <DocumentsUpload
        uploads={uploads}
        {...docUploadProps}
        buttonRef={otherDocsFieldRef}
        trackingOrigin="other"
        maxFiles={2}
        isReduced
      />
    </section>
  );
};
